import React from "react";
import { Outlet, useRoutes } from "react-router-dom";
import ForgetPassword from "./pages/auth/ForgetPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import ChangePassword from "./pages/profile/ChangePassword";
import Registration from "./pages/auth/Registration";
import EmailSentConfrimation from "./pages/auth/EmailSentConfrimation";
import Otp from "./pages/auth/Otp";
import Home from "./pages/Home";
import Consultation from "./pages/Consultation";
import Profile from "./pages/profile/Profile";
import ProfilePage from "./pages/profile/ProfilePage";
import EditProfile from "./pages/profile/EditProfile";
import EditBasicInformation from "./pages/profile/EditBasicInformation";
import PastMedicalHistory from "./pages/profile/PastMedicalHistory";
import EditMedicalHistory from "./pages/profile/EditMedicalHistory";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Login from "./pages/auth/Login";
import ProtectedRoute from "./components/ProtectedRoutes";
import PublicRoute from "./components/PublicRoutes";
import ConsultationHistory from "./pages/ConsultationHistory";
import { ProfileProvider } from "./context/ProfileContext";

function RoutesComponent() {
  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/login", element: (<PublicRoute><Login /></PublicRoute>) },
    { path: "/forgotpassword", element: (<PublicRoute><ForgetPassword /></PublicRoute>) },
    { path: "/resetpassword", element: (<PublicRoute><ResetPassword /></PublicRoute>) },
    { path: "/otp", element: (<PublicRoute><Otp /></PublicRoute>) },
    { path: "/registration", element: (<PublicRoute><Registration /></PublicRoute>) },
    { path: "/change-password", element: <ChangePassword /> },
    { path: "/terms-conditions", element: <TermsConditions /> },
    { path: "/terms-and-conditions", element: <TermsConditions /> },
    { path: "/privacy-policy", element: <PrivacyPolicy /> },
    { path: "/email-sent-confrimation", element: <EmailSentConfrimation /> },

    {
      path: "/",
      element:
        <ProfileProvider>
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        </ProfileProvider>
      ,
      children: [
        { path: "", element: <Home /> },
        { path: "profile", element: <Profile /> },
        { path: "profile-page", element: <ProfilePage /> },
        { path: "edit-profile", element: <EditProfile /> },
        { path: "edit-basic-information", element: <EditBasicInformation /> },
        { path: "past-medical-history", element: <PastMedicalHistory /> },
        { path: "edit-medical-history", element: <EditMedicalHistory /> },
        { path: "consultation-history", element: <ConsultationHistory /> },
        { path: "consultation", element: <Consultation /> },
      ],
    },
  ]);

  return routes;
}

export default RoutesComponent;
